import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { Button, Modal } from "react-bootstrap";
import { ClipLoader } from "react-spinners";

import _ from "lodash";

import { removeCategoryFromEquipmentUnit } from "../../../api";
import { checkForAPISuccess, showErrorToast, showSuccessToast } from "../../../Common/commonFunctions";

import { RESPONSE_REMOVE_CATEGORY_FAILED_CODE } from "../../../Common/constants";
import { DESELECT_COMPONENT, REMOVE_CATEGORY_FROM_EQUIPMENT_UNIT } from "../../../store/actions";

const RemoveCategory = props => {

    const dispatch = useDispatch();

    const [utils, setUtils] = useState({ 
        categoryCreatedComponents: [],
        categoryCreatedBearings: []
    });

    const returnBearingDeleteWarning = () =>
        <>
            <span>Following bearings inside the components will be deleted</span>
            {
                Object.keys(utils.categoryCreatedBearings).map(componentName => 
                    <div className="my-3">
                        <div>
                            <b>Component :</b> <span className="ml-1">{componentName}</span>
                        </div>
                        <div>
                            <b>Bearing(s) :</b>
                            <span className="ml-2">
                                {utils.categoryCreatedBearings[componentName]?.join(", ")}
                            </span>
                        </div>
                    </div>
                )
            }
        </>

    const returnSoftDeleteComponentWarning = () =>
        <>
            <span>Following components will be deleted and sensor(s) under it will be detached</span>
            {
                Object.keys(utils.categoryCreatedComponents).map(componentName => 
                    <div className="my-3">
                        <div>
                            <b>Component :</b> <span className="ml-1">{componentName}</span>
                        </div>
                        <div>
                            <b>Sensor(s) :</b>
                            <span className="ml-2">
                                {
                                    !_.isEmpty(utils.categoryCreatedComponents[componentName]) ?
                                        utils.categoryCreatedComponents[componentName].join(", ")
                                            :
                                        "-"
                                }
                            </span>
                        </div>
                    </div>
                )
            }
        </>

    const removeCategory = async (isForceRemove) => {
        const response = await removeCategoryFromEquipmentUnit({
            equipmentUnitId: props.id,
            isForceRemove: isForceRemove
        });
        if(checkForAPISuccess(response.data?.statusCode)) {
            const responseData = response?.data?.data;
            dispatch({
                type: REMOVE_CATEGORY_FROM_EQUIPMENT_UNIT,
                payload: {
                    equipmentUnitName: props.name,
                    equipmentId: props.equipmentId,
                    deletedComponentNames: !_.isEmpty(responseData?.deletedComponents) ? Object.keys(responseData?.deletedComponents) : {},
                    restoredComponents: responseData?.restoredComponents
                }
            });
            showSuccessToast("Category removed successfully");
            props.close();
        }
        else if(response?.data?.statusCode === RESPONSE_REMOVE_CATEGORY_FAILED_CODE) {
            console.log(response?.data);
            setUtils({
                categoryCreatedComponents: response?.data?.data?.components,
                categoryCreatedBearings: response?.data?.data?.bearings
            });
        }
        else {
            showErrorToast("Failed to remove category")
            props.close();
        }
        return response.data;
    }

    const removeCategoryMutation = useMutation(removeCategory);

    useEffect(() => {
        dispatch({ type: DESELECT_COMPONENT });
    }, [])

    return (
        <Modal backdrop="static" show onHide={() => props.close()}>
            <Modal.Header closeButton>
                <b className="f-17">Remove category</b>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {
                        removeCategoryMutation.isLoading ?
                            <div className="text-center my-5">
                                <ClipLoader color="#075978" />
                            </div>
                                :
                            <>
                                {
                                    !_.isEmpty(utils.categoryCreatedComponents) || !_.isEmpty(utils.categoryCreatedBearings) ?
                                        <div className="my-3">
                                            { !_.isEmpty(utils.categoryCreatedComponents) && returnSoftDeleteComponentWarning() }
                                            { !_.isEmpty(utils.categoryCreatedBearings) && returnBearingDeleteWarning() }
                                        </div>
                                            :
                                        <div className="my-5 font-weight-bold">
                                            Are you sure to remove category from this equipment unit?.
                                        </div>
                                }
                            </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={removeCategoryMutation.isLoading}
                    onClick={() => props.close()}
                    className="secondary-button"
                >
                    Cancel
                </Button>
                <Button
                    disabled={removeCategoryMutation.isLoading}
                    onClick={
                        () => removeCategoryMutation.mutate(
                            !_.isEmpty(utils.categoryCreatedComponents) ||
                            !_.isEmpty(utils.categoryCreatedBearings)
                        )
                    }
                >
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RemoveCategory;